"use client";

import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize18, lineHeightTight, fontWeightSemiBold } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority4 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightSemiBold, fontSize18, lineHeightTight);
const H4Styled = styled.h4.withConfig({
  componentId: "sc-12mz36o-0"
})(["", ";"], internalUseOnlyPriority4);

/**
 * The fourth level heading style. You can override the semantics by passing a different `renderAs` prop to still look like an `h4` but be an `h3` (or other heading) if needed.
 */
const H4 = ({
  children,
  renderAs,
  ...props
}) => /*#__PURE__*/_jsx(H4Styled, {
  as: renderAs,
  ...props,
  children: children
});
export default H4;
H4.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType
};